'use strict';

angular.module('msAssessment', ['msCore', 'msUtility']);